import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9acf4624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

import SpriteSource from '@/components/SpriteSource.vue'
  import LoadingBar from '@/components/LoadingBar.vue'

  import {inject, computed, ref, onMounted} from 'vue'
  import {useStore} from 'vuex'
  import {useRoute} from 'vue-router'

  import {useSizable} from '@/lib/sizable.js'

  import BubblesBackground from '@/components/BubblesBackground.vue'
  import NotificationContainer from '@/components/NotificationContainer.vue'

  import {t} from '@/lib/i18n.js'
  import router from './router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const bus = inject('bus')
  const root = ref(null)
  const route = useRoute()
  const store = useStore()
  const loading = computed(() => store.getters.loading)

  const isActive = computed(() => {
    return store.state.screenMode === 'active'
  })

  const {width, height} = useSizable(root)

  const offline = computed(() => store.state.offline)

  const offlineText = computed(() => t(store, 'offline'))

  const checkRTLParameter = () => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('rtl') === '1') {
      document.body.classList.add('rtl')
      console.log('RTL mode enabled')
    } else {
      document.body.classList.remove('rtl')
    }
  }

  window.addEventListener('offline', () => {
    store.state.offline = true

    bus.publish({
      event: 'DISCONNECT',
      data: {}
    })
  })

  window.addEventListener('online', () => {
    store.state.offline = false

    if (route.name === 'active') {
      router.replace({name: 'active'})
    } else {
      router.go(-1)
    }
  })

  onMounted(() => {
    checkRTLParameter()
  })

  const classObject = computed(() => {
    const w = width.value

    return {
      'is-gt-tiny': w > 300,
      'is-gt-small': w > 700,
      'is-gt-medium': w > 900,
      'is-gt-large': w > 1200,
      'is-gt-huge': w > 1920,
      'is-very-short': height.value < 700,
      'is-short': height.value < 900,
      'is-tall': height.value > 899,
      'is-quite-tall': height.value > 1100,
      'is-very-tall': height.value > 1500,
      'is-booth': !store.getters.experimentMode,
      'is-experiment': store.getters.experimentMode,
      'is-passive': store.state.screenMode === 'passive',
      'is-active': store.state.screenMode === 'active',
      'is-portrait': height.value >= width.value,
      'is-landscape': height.value < width.value
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["app", _unref(classObject)])
  }, [
    _createVNode(LoadingBar, { loading: _unref(loading) }, null, 8, ["loading"]),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(SpriteSource, {
        url: require('@/assets/svg/sprite.symbol.svg')
      }, null, 8, ["url"]),
      _createElementVNode("div", {
        class: _normalizeClass(["scroll-container", `is-${_unref(route).name}`])
      }, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({Component}) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (_unref(offline))
          ? (_openBlock(), _createBlock(NotificationContainer, {
              key: 0,
              class: "offline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(offlineText)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(isActive))
      ? (_openBlock(), _createBlock(BubblesBackground, { key: 0 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})